export interface NavItemChild extends NavItem {
    label: string;
    route: string;
    icon?: string;
}

export interface NavItem {
    label: string;
    icon?: string;
    route: string;
    level: number;
    index: number
    children?: NavItemChild[];
}
export const COMMON_NAVIGATION: NavItem[] = [
    { label: 'menu.dashboard', icon: 'home', route: '/dashboard', level: 0, index: 0 },
    { label: 'menu.clients', icon: 'groups', route: '/clients', level: 0, index: 1 },
    {
        label: 'menu.admin',
        icon: 'settings',
        route: '/admin',
        level: 0,
        index: 4,
        children: [
            { label: 'admin.settings', route: '/admin', index: 0, level: 1 },
        ]
    }
]

export const TRICHOLOGIS_NAVIGATION: NavItem[] = [
    {
        label: 'menu.appointments', icon: 'event', route: '/appointments', level: 0, index: 2, children: [
            { label: 'menu.treatments', icon: 'assignment', route: '/consultations', level: 1, index: 0 },
            { label: 'menu.new-treatment', icon: 'assignment_add', route: '/consultations/new-consultation', level: 1, index: 1 },
            { label: 'menu.form-builder', icon: 'app_registration', route: '/consultations/builder', level: 1, index: 2 },
        ]
    },
    { label: 'menu.reports', icon: 'assessment', route: '/reports', level: 0, index: 3 },
];

export const INTERIOR_DESIGNER_NAVIGATION = [
    { label: 'menu.tasks', icon: 'task_alt', route: '/tasks', level: 0, index: 3 },
]